import { render } from "./SocialFollow.vue?vue&type=template&id=a2aa11bc"
import script from "./SocialFollow.vue?vue&type=script&lang=js"
export * from "./SocialFollow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__